import './TopPage.css';

function TopPage() {

    return (
        <div className="top-page-wrapper">

            <div className="top-page">
                <div className="author-section">
                    <p>Par Nabil Hasnaoui</p>
                </div>
            </div>

        </div>
    );
}

export default TopPage;